import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Hotetec New Version**
 *
 * @exports bs_390
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let hotetecNewVersion;
    const hotelCodes = {
        1028793: 52844, // Zafiro Palace Andratx
        1028799: 3807, // Zafiro Palmanova
        1029405: 49426, // Zafiro Palace Palmanova
        1028794: 16022, // Zafiro Cala Mesquida
        1028797: 2931, // Zafiro Menorca
        1028792: 2544, // Zafiro Mallorca
        1028795: 44686, // Can Ribera by Zafiro
        1028791: 3882, // Zafiro Bahia
        1028789: 3948, // Zafiro Tropic
        1015359: 4516, // Zafiro Rey don Jaime
        1015358: 47257, // Zafiro Palace Alcudia
        1015360: 21537, // Zafiro Can Picafort
        1048120: 2445, // Gran Cervantes By Blue Sea
        1048117: 10190, // Blue Sea Club Martha's
        1048108: 46883, // Blue Sea Costa Bastian
        1048122: 4224, // Blue Sea Gran Playa
        1048124: 11671, // Blue Sea Puerto Resort
        1048112: 4196, // Blue Sea Arenal Tower
        1048129: 47225, // Blue Sea Cala Millor
        1048113: 6002, // Blue Sea Callao Garden
        1048109: 47442, // Blue Sea Costa Jardin & Spa
        1048126: 5964, // Blue Sea Costa Teguise Gardens
        1048125: 4084, // Blue Sea Costa Verde
        1048121: 2796, // Blue Sea Don Jaime
        1048115: 2696, // Blue Sea Es Bolero
        1048123: 6230, // Blue Sea Interpalace
        1048106: 4946, // Blue Sea Jandia Luz
        1048119: 6299, // Blue Sea Lagos De Cesar
        1048107: 52704, // Blue Sea Lanzarote Palm
        1048128: 5536, // Blue Sea Los Fiscos
        1048118: 4106, // Blue Sea Mediodia
        1048104: 46885, // Blue Sea Montevista Hawai
        1048114: 3919, // Blue Sea Piscis
        1048111: 2708, // Blue Sea Ses Cases D'Or
        1048110: 52253, // Bluesea Al Andalus
        1048116: 44176, // Le Printemps By Blue Sea
        1048127: 46884, // URBANSEA Atocha 113
        1049871: 53047, // BLUESEA Copacabana
        1048907: 71099, // Alexandre Hotel FrontAir Congress
        1048908: 5999, // Alexandre Hotel Gala
        1048909: 21363, // Alexandre Hotel Fira Congress
        1048910: 6041, // Alexandre Hotel La Siesta
        1048911: 6085, // Alexandre Hotel Troya
        1052463: 53117, // Zafiro Son Sabater
        1052464: 53118, // Zafiro Alzinar Mar
    };
    const vendorCodeByUsers = {
        1034154: 'ZAFI',
        1045567: 'BLUE',
        1045663: 'ALEX',
    };
    /**
       * @memberOf module:bs_390
       * @see {@link Price#on_hash_change}
       *
       * @param {object} ctx - The context object.
       */
    engine.onHashChange = function onHashChange(ctx) {
        setTimeout(thn.pageCheck, 600);
    };
    /**
      * @memberOf module:bs_390
      * @see {@link prestart}
      *
      * @param {object} ctx - The context object.
      */
    engine.boot = function boot() {
        const container = document.documentElement;
        if (container) {
            const hotetecPageRefresh = thn.debounce((mutations) => {
                const validMutationRooms = [...mutations].map((mutation) => mutation?.type === 'childList' && mutation.target && mutation.target.className && mutation.target.className === 'MuiCardMedia-root be10466  css-pqdqbj').filter(Boolean);
                const validMutationUrp = [...mutations].map((mutation) => mutation?.type === 'attributes' && mutation.target && mutation?.target.className && mutation.target.className === 'MuiInputBase-input MuiInput-input css-1erpd7j').filter(Boolean);
                if (validMutationRooms && validMutationUrp) {
                    thn.pageCheck();
                }
            }, 600);
            thn.observeDom(container, hotetecPageRefresh, {
                childList: true,
                attributes: true,
            });
            thn.shutdown(() => {
                hotetecPageRefresh.cancel();
                thn.stopObserveDom(container, hotetecPageRefresh);
            });
        }
    };
    function convertToISOString(dateString) {
        const localDateObject = new Date(dateString);
        const year = localDateObject.getFullYear(); // Get the required date components (in the local time zone)
        const day = String(localDateObject.getDate()).padStart(2, '0');
        const utcDate = Date.UTC(year, localDateObject.getMonth(), day); // Convert the local date to UTC time zone
        const utcDateObject = new Date(utcDate); // Create a new Date object with the date in UTC time zone
        const formattedUTCDate = utcDateObject.toISOString(); // Format the UTC date in ISO 8601 format
        return formattedUTCDate;
    }
    const endpointsCall = (function () {
        // Cache to store the previously computed results
        const cache = new Map();
        return function (params) {
            const cacheKey = JSON.stringify(params);
            if (cache.has(cacheKey)) {
                return cache.get(cacheKey);
            }
            const firstEndpointUrl = 'https://hotel.new.hotetec.com/webservice/integrations/pull/openSession';
            const firstEndpointBody = {
                clientCode: 'THN',
                systemCode: 'THN',
                username: 'HOTELSNETWORK23',
                password: '23HOTELSNETWORK',
            };
            const person = [];
            const guests = params.adults + params.children;
            for (let i = 1; i <= guests; i += 1) {
                if (i <= params.adults) {
                    person.push({ age: 30 });
                }
                else {
                    person.push({ age: 5 });
                }
            }
            const sessionRequest = new XMLHttpRequest();
            sessionRequest.open('POST', firstEndpointUrl, false);
            sessionRequest.setRequestHeader('Content-Type', 'application/json');
            sessionRequest.send(JSON.stringify(firstEndpointBody));
            if (sessionRequest.status !== 200) {
                return '';
            }
            const dataSession = JSON.parse(sessionRequest.responseText);
            if (!dataSession.sessionId) {
                return '';
            }
            const secondEndpointUrl = 'https://hotel.new.hotetec.com/webservice/integrations/meta/bookingEngineUrl';
            const secondEndpointBody = {
                sessionId: dataSession.sessionId,
                languageCode: params.language,
                currency: params.currency,
                hotelCode: hotelCodes[thn.data.propertyId],
                vendorCode: vendorCodeByUsers[thn.data.accountUserId],
                dateFrom: convertToISOString(params.date_begin), // Need the date format "2023-01-15T00:00:00.000Z"
                dateTo: convertToISOString(params.date_end),
                distribution: [{
                        id: 1,
                        person: person,
                    }],
                mealPlanCode: 'null',
                promotionalCode: 'null',
            };
            const deepLinkRequest = new XMLHttpRequest();
            deepLinkRequest.open('POST', secondEndpointUrl, false);
            deepLinkRequest.setRequestHeader('Content-Type', 'application/json');
            deepLinkRequest.send(JSON.stringify(secondEndpointBody));
            if (deepLinkRequest.status !== 200) {
                return '';
            }
            const deepLinkData = JSON.parse(deepLinkRequest.responseText);
            const finalUrl = deepLinkData?.bookingEngineUrl;
            // Store the result in the cache before returning it
            cache.set(cacheKey, finalUrl);
            return finalUrl;
        };
    }());
    /**
     * @memberOf module:bs_390
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        ctx.newUrl = endpointsCall(ctx.newData);
        return ctx;
    };
    /**
   * @memberOf module:bs_390
   * @this thn.widgets.price
   * @see {@link Price#observe_dom}
   *
   * @param {object} ctx - The context object.
   */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#app-container');
        if (container && !hotetecNewVersion) {
            hotetecNewVersion = thn.debounce(() => {
                thn.languageCheck();
                thn.widgets.price.refresh();
            }, 1000);
            thn.observeDom(container, hotetecNewVersion, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.pageUnload(() => {
                hotetecNewVersion.cancel();
                thn.stopObserveDom(container, hotetecNewVersion);
                hotetecNewVersion = null;
            });
        }
    };
    /**
       * @memberOf module:bs_390
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const lang = document.querySelector('#language-selector')?.textContent;
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_390
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = !!document.querySelector('#login-selector')?.getAttribute('aria-label') || !document.querySelector('#personLogin form');
        return isLogged;
    };
    /**
      *
      * @memberOf module:bs_390
      *
      */
    const roomDetailsParseData = (numAdults, numChildren, nights) => {
        const dataLayer = window.dataLayer;
        const roomDataLayerObject = thn.objectGet(dataLayer, 'ecommerce', { first: false })?.impressions || thn.objectGet(dataLayer, 'ecommerce', { first: false })?.items;
        if (thn.empty(roomDataLayerObject)) {
            return {};
        }
        const roomDetailsArray = [];
        roomDataLayerObject?.forEach((room) => {
            const roomName = room?.variant || room?.item_variant;
            const roomAdults = numAdults;
            const roomChildren = numChildren;
            const roomType = getRoomType(roomName);
            const roomData = {
                id: '',
                name: roomName,
                adults: roomAdults,
                children: roomChildren,
                type: roomType,
                prices: [],
            };
            const ratesInfo = room.options;
            ratesInfo?.forEach((rate) => {
                const rateName = rate?.dimension3 || rate?.tarifa;
                const ratePrice = thn.parseNumber(rate?.price);
                const breakfastEl = rate?.dimension4 || rate?.regimen;
                const hasBreakfast = breakfastEl?.includes('BB');
                const isRefundable = rateName?.includes('Flexible');
                let pricePerNight;
                if (ratePrice) {
                    pricePerNight = ratePrice / nights;
                }
                const rateInfo = {
                    id: '',
                    name: rateName,
                    total_night: pricePerNight,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                roomData.prices.push(rateInfo);
            });
            roomDetailsArray.push(roomData);
        });
        return roomDetailsArray;
    };
    /**
         * @memberOf module:bs_390
         * @this thn.widgets.price
         * @see {@link Price#set_data}
         *
         * @param {object} ctx - The context object.
         */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        const dlData = dataLayer.filter((object) => (object?.event === 'view_item' || object?.event === 'begin_checkout') && object?.page?.title?.match(/roomAvailability/));
        const lastDataPushed = dlData.sort((a, b) => b['gtm.uniqueEventId'] - a['gtm.uniqueEventId'])[0];
        const dataLayerInfo = thn.objectGet(lastDataPushed, 'ecommerce', { first: false })?.impressions?.[0] || thn.objectGet(lastDataPushed, 'items')?.[0];
        // Dates
        const dateBeginDatalayer = dataLayerInfo?.dimension1?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') || dataLayerInfo?.check_in?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        const dateEndDatalayer = dataLayerInfo?.dimension2?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') || dataLayerInfo?.check_out?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        let nights;
        if (dateBeginDatalayer && dateEndDatalayer) {
            widgetData.date_begin = dateBeginDatalayer;
            widgetData.date_end = dateEndDatalayer;
            nights = thn.daysBetween(widgetData.date_begin, widgetData.date_end);
        }
        // Guests
        const guestsArray = (dataLayerInfo?.metric3 || dataLayerInfo?.pax)?.split('-');
        const adults = thn.parseNumber(guestsArray?.[0]) || 2;
        const children = thn.parseNumber(guestsArray?.[1]) || 0;
        widgetData.adults = adults;
        widgetData.children = children;
        widgetData.guests = adults + children;
        // Price, currency
        const price = thn.parseNumber(dataLayerInfo?.price);
        const currency = dataLayerInfo?.currencyCode || dataLayerInfo?.currency;
        if (price && currency && nights) {
            widgetData.price = price / nights;
            widgetData.currency = currency;
            widgetData.room_details = roomDetailsParseData(adults, children);
            widgetData.set = true;
        }
        else if (widgetData.date_begin && widgetData.date_end) {
            widgetData.no_rooms = true;
        }
        return widgetData;
    };
    /**
         * @memberOf module:bs_390
         * @this thn.widgets.booking
         * @see {@link Booking#set_data}
         *
         * @param {object} ctx - The context object.
         */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window?.dataLayer.filter((object) => (object?.event === 'purchase'));
        const datalayerInfo = thn.objectGet(dataLayer, 'ecommerce', { first: false })?.purchase || thn.objectGet(dataLayer, 'ecommerce', { first: false });
        const bookingId = datalayerInfo?.actionField?.id || datalayerInfo?.transaction_id;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        // booking ID
        widgetData.booking_id = bookingId;
        // Dates
        const dateCheckIn = datalayerInfo?.products?.[0]?.dimension1 || datalayerInfo?.items?.[0]?.check_in;
        const dateCheckOut = datalayerInfo?.products?.[0]?.dimension2 || datalayerInfo?.items?.[0]?.check_out;
        widgetData.date_begin = dateCheckIn?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        widgetData.date_end = dateCheckOut?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
        // Guests
        const guestsArray = datalayerInfo?.products?.[0]?.metric3?.split('-') || datalayerInfo?.items?.[0]?.pax?.split('-');
        const adults = thn.parseNumber(guestsArray[0]) || 2;
        const children = thn.parseNumber(guestsArray[1]) || 0;
        widgetData.adults = adults;
        widgetData.children = children;
        widgetData.guests = adults + children;
        // Price & Currency
        const price = datalayerInfo?.actionField?.revenue || datalayerInfo?.value;
        widgetData.price = thn.parseNumber(price);
        widgetData.currency = datalayerInfo?.actionField?.currencyCode || datalayerInfo?.items[0]?.currency;
        widgetData.promocode = thn.objectGet(window.dataLayer, 'ecommerce')?.items?.[0]?.coupon;
        return widgetData;
    };
    /**
     * @memberOf module:bs_390
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = thn.objectGet(window.dataLayer, 'ecommerce')?.items?.[0]?.coupon;
        ctx.promocode = promocode || '';
        return ctx.promocode;
    };
    return engine;
}

export { factory };
